// Mobile data with MrGamb keywords for cloaking simulation
export const mobileData = {
  header: {
    title: "Deneme Bonusu Veren Siteler 2025",
    subtitle: "Free Spin Veren Siteler ve Casino Bonusları",
    logo: "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico"
  },
  hero: {
    title: "MrGamb 2025 Güncel Giriş Adresi",
    subtitle: "Deneme Bonusu Veren Siteler ve Casino Bonusları",
    buttons: [
      { text: "Telegram", color: "purple", link: "https://t.me/mrgambofficial" },
      { text: "Microsoft Teams", color: "orange", link: "https://teams.microsoft.com/l/team/19%3A19%40thread.tacv2/members?tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47" },
      { text: "MR Gamb", color: "purple", link: "https://mr-run.com" }
    ]
  },
  services: [
    {
      id: 1,
      title: "MrGamb Media ile Dijital Gücünü Artır",
      content: "MrGamb Media, markaların dijital dünyada daha görünür olmasını sağlayan yenilikçi medya çözümleri sunar. İster küçük bir girişim olun ister global ölçekte faaliyet gösterin, mrgamb medya ekibimiz size özel SEO, reklam yönetimi ve içerik stratejileri hazırlar. Böylece arama motorlarında ilk sıralarda yer alabilir, daha fazla kullanıcıya ulaşabilirsiniz. MrGamb ile sadece trafik değil, gerçek dönüşüm odaklı sonuçlar elde edersiniz.",
      icon: "📈",
      color: "purple"
    },
    {
      id: 2,
      title: "Mrgamb Medya ile Marka Bilinirliğini Yükselt",
      content: "Mrgamb medya, sosyal medya yönetiminden içerik üretimine kadar geniş kapsamlı dijital pazarlama desteği verir. Ekip, marka kimliğinizi doğru hedef kitleye ulaştırmak için özel çözümler geliştirir. MrGamb Media sayesinde markanız online dünyada güçlü bir imaj kazanır. SEO uyumlu içerikler, profesyonel görsel tasarımlar ve etkili reklam kampanyaları ile büyüme sürecinizi hızlandırabilirsiniz.",
      icon: "🌐",
      color: "purple"
    }
  ],
  doctor: {
    name: "MrGamb Medya",
    title: "Dijital Güçlü Ağınız",
    bio: "MrGamb Medya, markaların dijital dünyada daha görünür olmasını sağlayan yenilikçi medya çözümleri sunar. İster küçük bir girişim olun ister global ölçekte faaliyet gösterin, mrgamb medya ekibimiz size özel SEO, reklam yönetimi ve içerik stratejileri hazırlar. Böylece arama motorlarında ilk sıralarda yer alabilir, daha fazla kullanıcıya ulaşabilirsiniz. MrGamb ile sadece trafik değil, gerçek dönüşüm odaklı sonuçlar elde edersiniz.",
    image: "https://assets.mrgambcommunity.com/CaseGamb.png",
    rating: 3.0,
    yelpRating: "3.0 (72 reviews)",
    reviewHighlights: [
      {
        platform: "MRGamb",
        author: "Ay***",
        text: "Mr Gamb ekibi sayesinde sitem kısa sürede yükseldi. mrgamb medya SEO paketleri şeffaf ve sonuç odaklı, mrgemb ile reklam optimizasyonu da gözle görülür fark yarattı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Me***",
        text: "mrgamp içerik stratejileri ile organik trafik kalıcı hale geldi. MrGamb Media raporları net, iletişim hızlı. Her ay istikrarlı büyüme görüyorum.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Se***",
        text: "Sosyal medya yönetiminde mrgemp yaklaşımı harika. MrGamb kampanyaları ile etkileşim ve dönüşüm aynı anda arttı. Tavsiye ederim.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Bu***",
        text: "MrGamb medya ekibi web sitesi optimizasyonunda teknik hataları hızlıca çözdü. mrgamb anahtar kelimelerinde ilk sayfaya çıktık.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ka***",
        text: "mrgemb içerik planı ve backlink stratejisiyle satışlarımız arttı. MrGamb Media sürekli A/B testi yaparak bütçeyi verimli kullandı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "El***",
        text: "Görsel tasarım ve sayfa hızında büyük iyileşme oldu. Mr Gamb SEO teknikleri sayesinde core web vitals değerlerimiz yeşile döndü.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ha***",
        text: "mrgamp reklam yönetimi ile tıklama başı maliyet düştü, dönüşüm oranı yükseldi. MrGamb raporları anlaşılır ve aksiyon odaklı.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Ni***",
        text: "MrGamb Media ile kurumsal blog stratejisi kurduk. mrgemp uzun kuyruklu kelimelerde hızlıca sıralama aldık. Süreç çok profesyoneldi.",
        rating: 5
      },
      {
        platform: "MRGamb",
        author: "Öz***",
        text: "mrgamb teknik SEO denetimi sonrasında site haritaları ve schema düzenlendi. MrGamb sayesinde organik görünürlük belirgin arttı.",
        rating: 5
      }
    ]
  },
  medicalServices: [
    { name: "SEO", icon: "🚀" },
    { name: "Reklam Yönetimi", icon: "📢" },
    { name: "İçerik Stratejileri", icon: "📝" },
    { name: "Sosyal Medya Yönetimi", icon: "📱" },
    { name: "Görsel Tasarım", icon: "🎨" },
    { name: "Web Sitesi Tasarımı", icon: "💻" },
    { name: "Web Sitesi Geliştirme", icon: "⚙️" },
    { name: "Web Sitesi Optimizasyonu", icon: "⚡" },
    { name: "Web Sitesi Analizi", icon: "📊" }
  ],
  insurance: {
    description: "MrGamb Medya olarak dijital pazarlama ve SEO alanında güvenilir çözümler sunuyoruz. Markaların online dünyada başarılı olması için kapsamlı medya hizmetleri veriyoruz.",
    providers: [
      "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico",
      "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico",
      "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico",
      "https://assets.mrgambcommunity.com/mrgambmedia/mrgambmedia.ico"
    ]
  },
  contact: {
    location: "MrGamb Medya - Dijital Pazarlama Merkezi",
    hours: "7/24 Dijital Destek",
    parking: "Online platform - Her yerden erişim"
  },
  testimonials: [
    {
      platform: "MRGamb",
      author: "Ay***",
      text: "Mr Gamb ekibi sayesinde sitem kısa sürede yükseldi. mrgamb medya SEO paketleri şeffaf ve sonuç odaklı, mrgemb ile reklam optimizasyonu da gözle görülür fark yarattı.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Me***",
      text: "mrgamp içerik stratejileri ile organik trafik kalıcı hale geldi. MrGamb Media raporları net, iletişim hızlı. Her ay istikrarlı büyüme görüyorum.",
      rating: 5
    },
    {
      platform: "MRGamb",
      author: "Se***",
      text: "Sosyal medya yönetiminde mrgemp yaklaşımı harika. MrGamb kampanyaları ile etkileşim ve dönüşüm aynı anda arttı. Tavsiye ederim.",
      rating: 5
    }
  ],
  boxes: [
    {
      id: 1,
      title: "MR Gamb Güncel Giriş Adresi",
      content: "MR Gamb güncel giriş adresi ile casino oyunlarında büyük kazançlar elde edin. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb güncel giriş adresleri ile deneme bonusu ve free spin fırsatlarını kaçırmayın. En yüksek RTP oranları ile slot oyunları, canlı casino ve poker masalarında profesyonel oyun deneyimi yaşayın.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/mrgamb.png"
    },
    {
      id: 2,
      title: "Bahiso Güncel Giriş Adresi",
      content: "Bahiso güncel giriş adresi ile casino dünyasında fark yaratın. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb casino platformları arasında en güvenilir seçenek. Deneme bonusu, free spin ve günlük promosyonlar ile kazancınızı katlayın. HD kalitede canlı casino deneyimi ve mobil uyumlu tasarım.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/bahiso.png"
    },
    {
      id: 3,
      title: "Betbeymen Güncel Giriş Adresi",
      content: "Betbeymen güncel giriş adresi ile casino oyunlarında liderliği yakalayın. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb güncel giriş adresleri arasında en hızlı ödeme yapan platform. Slot oyunları, canlı casino, poker ve baccarat masalarında yüksek kazanç fırsatları. 7/24 müşteri desteği ve güvenli oyun ortamı.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/betbeymen.gif"
    },
    {
      id: 4,
      title: "Betesbet Güncel Giriş Adresi",
      content: "Betesbet güncel giriş adresi ile casino dünyasında öncü olun. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb casino siteleri arasında en yüksek bonus oranları. Deneme bonusu, free spin ve haftalık promosyonlar ile kazancınızı artırın. Mobil uyumlu tasarım ve hızlı para çekme işlemleri.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/betesbet.png"
    },
    {
      id: 5,
      title: "Betforce Güncel Giriş Adresi",
      content: "Betforce güncel giriş adresi ile casino oyunlarında güçlü olun. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb güncel giriş adresleri arasında en güçlü platform. Binlerce slot oyunu, canlı casino masaları ve poker turnuvaları. Yüksek RTP oranları ve mega jackpot fırsatları ile kazancınızı katlayın.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/betforce.png"
    },
    {
      id: 6,
      title: "Jackbom Güncel Giriş Adresi",
      content: "Jackbom güncel giriş adresi ile casino oyunlarında jackpot kazanın. MrGamb, Mistır gemb, Mrgemb, Mrgemp, Mrgamp, Mırgemb güncel giriş adresleri arasında en büyük jackpot fırsatları. Mobil casino uygulaması ile her yerden oynayın. Android ve iOS cihazlarda kesintisiz casino deneyimi. Hızlı para yatırma ve çekme işlemleri.",
      link: "https://mr-run.com",
      icon: "https://sitesconfig.pages.dev/logolar/jackbom.png"
    }
  ]
};
